import { useInfiniteQuery, useMutation, useQuery, useQueryClient } from "react-query";

import { GetProductsParams } from "../types";

import { deleteProduct, getProducts, PRODUCTS_PAGE_SIZE } from "./index";

export const useGetProducts = (params: GetProductsParams) => {
  return useQuery(["get-products", { ...params }], () => getProducts(params));
};

export const useInfiniteProducts = (params: {
  group?: number;
  search?: string;
}) => {
  return useInfiniteQuery(
    ["get-products-infinite", params.group, params.search ?? ""],
    ({ pageParam = 1 }) =>
      getProducts({
        page: pageParam,
        pageSize: PRODUCTS_PAGE_SIZE,
        group: params.group,
        search: params.search,
      }),
    {
      getNextPageParam: (lastPage, allPages) => {
        const list = lastPage ?? [];
        if (list.length < PRODUCTS_PAGE_SIZE) return undefined;
        return allPages.length + 1;
      },
      // При смене группы/поиска (новый queryKey) список начинается с первой страницы, не дополняется
      keepPreviousData: false,
    }
  );
};

const useSuccess = () => {
  const queryClient = useQueryClient();

  return () => {
    queryClient.invalidateQueries({ queryKey: ["get-products"] });
    queryClient.invalidateQueries({ queryKey: ["get-products-infinite"] });
  };
};

export const useDeleteProduct = () => {
  const onSuccess = useSuccess();

  return useMutation(["delete-product"], deleteProduct, {
    onSuccess,
  });
};
